import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { PCFShadowMap, TextureLoader } from 'three'


/* Loaders */

// GLTF Loader
const gltfLoader = new GLTFLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader
/**
 * Base
 */
// Debug
// const gui = new dat.GUI()
// const debugObject = {}

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/* Update All Materials */

const updateAllMaterials = () =>
{
    scene.traverse((child) =>
    {
        if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial){
            child.material.envMap = environmentMap
            child.material.envMapIntensity = debugObject.envMapIntensity
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true
        }
        
    })
}


/* Environment Map */

const environmentMap = cubeTextureLoader.load([
    '/textures/environmentMaps/deer/px.png',
    '/textures/environmentMaps/deer/nx.png',
    '/textures/environmentMaps/deer/py.png',
    '/textures/environmentMaps/deer/ny.png',
    '/textures/environmentMaps/deer/pz.png',
    '/textures/environmentMaps/deer/nz.png',
])
environmentMap.encoding = THREE.sRGBEncoding
scene.background = environmentMap
scene.environment = environmentMap

// debugObject.envMapIntensity = 2.5
// gui.add(debugObject, 'envMapIntensity').min(0).max(10).step(.0001).onChange(updateAllMaterials)

/* Models */
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')
gltfLoader.setDRACOLoader(dracoLoader)
gltfLoader.load('/models/Drone/4SiteAdvantageDronew-scene.glb',
    (gltf) => {
        gltf.scene.scale.set(10,10,10)
        gltf.scene.position.set(30, 0, 0)
        gltf.scene.rotation.y= Math.PI * .25 
    scene.add(gltf.scene)
    // gui.add(gltf.scene.rotation, 'y').min(-Math.PI).max(Math.PI).step(.001).name('rotation')
    updateAllMaterials()
    }
)


/* Lights */

// Directional Light
const directionalLight = new THREE.DirectionalLight(0xffffff, 8.633)
directionalLight.position.set(-500, 18.878, -150.739)
// directionalLight.castShadow = true
directionalLight.shadow.camera.far = 15
directionalLight.shadow.mapSize.set(1024,1024)
directionalLight.shadow.normalBias = .05
scene.add(directionalLight)


// const directionalLightCameraHelper = new THREE.CameraHelper(camera)
// scene.add(directionalLightCameraHelper)

// Gui Additions
// gui.add(directionalLight, 'intensity').min(0).max(100).step(.001).name('lightIntensity')
// gui.add(directionalLight.position, 'x').min(-500).max(100).step(.001).name('lightX')
// gui.add(directionalLight.position, 'y').min(-500).max(100).step(.001).name('lightY')
// gui.add(directionalLight.position, 'z').min(-500).max(100).step(.001).name('lightZ')



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(-10, 30, - 30)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.enableZoom = false
controls.autoRotate = true
controls.autoRotateSpeed = .05

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ReinhardToneMapping
renderer.toneMappingExposure = 2
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFShadowMap


// gui.add(renderer, 'toneMapping', {
//     No: THREE.NoToneMapping,
//     Linear: THREE.LinearToneMapping,
//     Reinhard: THREE.ReinhardToneMapping,
//     Cineon: THREE.CineonToneMapping,
//     ACESFilmic: THREE.ACESFilmicToneMapping
// }).onFinishChange(updateAllMaterials)

// gui.add(renderer, 'toneMappingExposure').min(0).max(10).step(.001)

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()




    // Render
    renderer.render(scene, camera)

    // // Camera Animation
    // camera.position.x = Math.sin(elapsedTime + 2) * .1
    // camera.position.y = Math.sin(elapsedTime + 3) * .1
    // camera.lookAt(gltf.scene.position)
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()